import { AxiosResponse } from 'axios'
import { environments } from 'environments/environments'
import { DebitNoteRequestDTO } from 'pages/FinancialManagement/components/DebitNote/types'
import api from './api'

const { ENDPOINT_REPORT_CSV } = environments

export const generateDebitNote = async (
   request: DebitNoteRequestDTO
): Promise<AxiosResponse<Blob>> => {
   return api.post(
      `${ENDPOINT_REPORT_CSV}/relatorios/nota-debito`,
      request,
      {
         responseType: 'blob',
         headers: {
            Accept: 'application/pdf'
         }
      }
   )
}